import React, { PureComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight } from '@fortawesome/free-regular-svg-icons';
import './Tier2.css';


class Tier2 extends PureComponent {

	renderCustodians(data) {
		const {
			selectItem,
		} = this.props;

		return data.map((cust, idx) => {
			return (
				<div className='col-md-5'>
					<div
						className='tier2Box'
						onClick={() => selectItem(idx)}
					>
						<div className='col-md-10' style={{marginTop:'4px'}}>{cust.name}</div> 
						<div className='col-md-2'>
							<FontAwesomeIcon icon={faArrowAltCircleRight} style={{fontSize:'28px', color:'#5060F6'}}/>
						</div>
					</div>
				</div>
			);
		});
	}

	render() {
		const {
			data,
		} = this.props;

		return (
			<div className='row'>
				{this.renderCustodians(data)}
			</div>
		)
	}

}

export default (Tier2);
